import { Component, OnDestroy, OnInit } from '@angular/core';
import { CookiesService } from 'src/app/services/cookies.service';
import { IndexDBServiceService } from '../../common/index-dbservice.service';
import { NavigationEnd, Router } from '@angular/router';
import { MatCard } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TruncateWordsPipe } from '../../pipes/trancate-text.pipe';
import { filter, Subject, takeUntil } from 'rxjs';
import { BookingContentService } from "src/app/services/bookingContentService/booking-content.service";
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
  imports: [MatCard, MatButton, MatIcon, TruncateWordsPipe]
})
export class CookieBannerComponent implements OnInit, OnDestroy {
    content: any;
  showCookieBanner = false;
  /** Waiting/Imperva page must not show cookie consent. */
  hideOnImpervaPage = false;
  latestCookieVersion = '';
  cookieText: string = `SAUDIA uses necessary cookies to personalise content and ads, to provide social media features, and to analyse our
        traffic. We also share information about your use of our site with our social media, advertising and .`;
  private readonly destroy$ = new Subject<void>();
  dictionaryContent:any;
  cookieBannerDescription = '';

  constructor(private readonly bookingContentService: BookingContentService, private readonly cookieConsentService: CookiesService, private readonly indexDB: IndexDBServiceService, private readonly router: Router,private readonly dictionaryContentService: DisctionaryContent) {
  }
  ngOnInit(): void {
    this.updateImpervaVisibility(this.router.url);
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event) => this.updateImpervaVisibility(event.urlAfterRedirects));
    this.checkPolicyVersio();
      this.bookingContentService.content$.subscribe((res: any) => { this.content = res; });

      this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)) .subscribe((res: any) => {
        this.dictionaryContent = res;
        this.cookieBannerDescription =
          this.decodeCookieBannerContent( res?.['b2b.booking.cookiebannerdescription'] );
      });

  }
//sitecore
  private decodeCookieBannerContent(value: string): string {
    if (!value) {
      return '';
    }

    let html = value;

    // Decode Unicode
    html = html.replace(
      /\\u([0-9a-fA-F]{4})/g,
      (_, hex) => String.fromCharCode(parseInt(hex, 16))
    );

    // Decode escaped quotes
    html = html.replace(/\\"/g, '"');

    // Decode HTML quotes
    html = html.replace(/&quot;/g, '"');

    // Fix href=""URL""
    html = html.replace(
      /href=""(https?:\/\/[^"]+)""/gi,
      'href="$1"'
    );

    // Fix target=""_blank""
    html = html.replace(
      /target=""_blank""/gi,
      'target="_blank"'
    );

    // Fix rel=""noopener noreferrer""
    html = html.replace(
      /rel=""noopener noreferrer""/gi,
      'rel="noopener noreferrer"'
    );

    return html;
  }


  private updateImpervaVisibility(url: string): void {
    const path = (url || '').split('?')[0].split('#')[0];
    this.hideOnImpervaPage = path === '/imperva' || path.endsWith('/imperva');
  }

  async checkPolicyVersio() {
    let exists: boolean = await this.indexDB.keyExists('cookieAccepted');
    let isVersionExist: boolean = await this.indexDB.keyExists('cookiePolicyVersion');
    let isAccepted: any = undefined;
    if (exists) {
      isAccepted = await this.indexDB.getDataInIndexDB('cookieAccepted').then((res: any) => {
        return res;
      });
    } else {
      this.showCookieBanner = true;
    }
    this.cookieConsentService.getUserAcceptedVersion();
    this.cookieConsentService.getLatestPolicyVersion().subscribe((res: any) => {
      this.latestCookieVersion = res;
      const userVersion = this.cookieConsentService.currentVersion;
      if (exists && isVersionExist) {

        if ((userVersion !== this.latestCookieVersion) && (userVersion && this.latestCookieVersion)) {
          this.showCookieBanner = isAccepted == 'true';
        }
        this.cookieConsentService.isConsent.next(isAccepted)
      } else if (exists && !isVersionExist) {
        this.showCookieBanner = false;
      } else if ((!exists && !isVersionExist) || (!exists && isVersionExist)) {
        this.showCookieBanner = true;
      }
    });
  }

  acceptCookies(): void {
    this.cookieConsentService.saveUserAcceptedVersion(this.latestCookieVersion);
    this.showCookieBanner = false;
  }

  declineCookies(): void {
    this.cookieConsentService.decline();
    this.showCookieBanner = false;

  }
  openCookiePolicy(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    const newTab = window.open('', '_blank', 'noopener,noreferrer');
    if (newTab) {
      newTab.location.href = 'https://www.saudia.com/en-IN/information/terms-and-conditions/cookie-policy';
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
